import { render, staticRenderFns } from "./CoinHealthList.vue?vue&type=template&id=594011a4&scoped=true&"
import script from "./CoinHealthList.vue?vue&type=script&lang=js&"
export * from "./CoinHealthList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "594011a4",
  null
  
)

export default component.exports